import { type SimpleFetch } from '@spotify-confidence/sdk';

type ReadOnlyProvider = () => boolean;

const WRITE_ENDPOINTS = [
  '/flags:apply',
  '/events:publish',
  '/telemetry:upload',
];

const isWriteRequest = (request: Request): boolean =>
  WRITE_ENDPOINTS.some(endpoint => request.url.endsWith(endpoint));

const blockedResponse = (request: Request): Response => {
  if (request.url.endsWith('/events:publish')) {
    return new Response(JSON.stringify({ errors: [] }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  return new Response(null, { status: 200 });
};

export const createReadOnlyFetchImplementation = (
  readOnlyProvider: ReadOnlyProvider,
  fetchImplementation: SimpleFetch = fetch,
): SimpleFetch => {
  return async request => {
    if (readOnlyProvider() && isWriteRequest(request)) {
      return blockedResponse(request);
    }

    return fetchImplementation(request);
  };
};
